import viewportEmitter from 'lib/viewport-emitter'
import { getPagePosition } from 'lib/helpers/dom-metrics'

const watchlist = []

function maybeShowImage (img, screenTop, screenBottom) {
  const imgPosition = getPagePosition(img)
  if (imgPosition.bottom > screenTop && imgPosition.top < screenBottom) {
    img.src = img.dataset.visibleSrc
    delete img.dataset.visibleSrc
    return true
  }
  return false
}

function onScroll () {
  if (watchlist.length === 0) {
    return
  }
  const screenTop = viewportEmitter.scrollY()
  const screenBottom = screenTop + viewportEmitter.clientHeight()
  for (let i = watchlist.length - 1; i >= 0; i--) {
    const img = watchlist[i]
    if (maybeShowImage(img, screenTop, screenBottom)) {
      watchlist.splice(i, 1) // Image was shown, so we remove it from the list of watched images
    }
  }
}

viewportEmitter.on('scroll', onScroll)

window.addEventListener('cmpb-layout-loaded', function (event) {
  var images = event.layout.querySelectorAll('.cmpb-block-image img[data-visible-src]')
  const screenTop = viewportEmitter.scrollY()
  const screenBottom = screenTop + viewportEmitter.clientHeight()
  for (const img of [...images]) {
    if (!maybeShowImage(img, screenTop, screenBottom)) {
      watchlist.push(img) // Image was not shown, so we add it to the list of watched images
    }
  }
})
